import { SplitFactory } from "@splitsoftware/splitio";
import { Attributes, IClient, ISDK } from "@splitsoftware/splitio/types/splitio";
import useFeatureFlagsStore from "@/store/feature-flags";

const COMMON_ATTRIBUTES = { targetApp: "frontend" };

const create = async (key: string): Promise<IClient> => {
  const splitFactory: ISDK = SplitFactory({
    core: {
      authorizationKey: window.env.VUE_APP_SPLITIO_TOKEN ?? "",
      key: key,
    },
    startup: {
      readyTimeout: 2,
    },
  });

  const client = splitFactory.client();

  client.on(client.Event.SDK_UPDATE, () => {
    useFeatureFlagsStore().setTreatments();
  });

  await client.ready();

  return client;
};

const destroy = async (client: IClient) => await client.destroy();

const treatments = (client: IClient, features: string[], attributes: Attributes = {}) =>
  client.getTreatmentsWithConfig(features, { ...COMMON_ATTRIBUTES, ...attributes });

export default { create, destroy, treatments };
